import { Component, Input, OnInit, TemplateRef, } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'; 
import { ClientService } from '../_services/client.service';
import { TokenStorageService } from '../_services/token-storage.service';


@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html'
})
export class ClientsComponent implements OnInit {
  contactUUID: string = "";
  searchInfo: string = "";
  clientInfo: any;
  isSearch: boolean = false;
  p: number = 0;
  total: number = 0;
  no_results_message: string = "";
  filter = 'all';
  loading_msg = 'Chargement en cours ';
  diplay_loading = this.loading_msg;
  isForeman:boolean = false;
  userAccess:any;

  searchClientForm: FormGroup = new FormGroup({
    search_client: new FormControl("")
  })

  constructor(
    private tokenStorage: TokenStorageService,
    private client: ClientService
  ) { }
  

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.userAccess = this.tokenStorage.getUserAccess()|| "";
    console.log('this.userAccess clients', this.userAccess);
    if( this.userAccess == 4)
      this.isForeman = true;

    this.getClients();
  }

  getClients(): void {
    this.isSearch = false;
    this.diplay_loading =  this.loading_msg;
    
    this.client.getClients$(this.contactUUID, this.p).subscribe((data) => {

      console.log('data:', data.records);
      this.diplay_loading = '';
      this.clientInfo = data.records;
      this.total = data.count;
    })
  }

  changeFilter(btnFilter:string){
    console.log("function called", btnFilter);
    this.filter = btnFilter;
    this.getClients();
    //window.open('../myURL/mypage.jsp?rurl=' + encodeURIComponent($('display').attr('href')));
  }

  pageChangeEvent(event: number){
    this.p = event - 1;

    if (this.isSearch) {
      this.searchClient(this.searchInfo);
    }
    else {
      this.getClients();
    }
  }

  onSubmit(values: any): void {
    this.p = 0;
    this.searchInfo = values.search_client;
    this.searchClient(this.searchInfo);
  }

  searchClient(search: string): void {
    this.isSearch = true;
    this.diplay_loading =  this.loading_msg;

    this.client.searchClient$(this.contactUUID, search, this.p).subscribe({
      next: (data: any) => {
        this.diplay_loading = '';
        this.clientInfo = data.records;
        this.total = data.count;
        console.log("search results", data);
        if(this.total == 0){ this.no_results_message = 'Aucun résultat de la recherche: ' + search;}
      },
      error: (err: any) => {
        console.log("Something went wrong searching clients: ", err.statusText)
      }
    });
  }

  deleteClient(clientId: number, client_fname: string, client_lname:string, client_updated:string): void {

    if(confirm("Voulez-vous supprimer le client \n"+ client_fname + ' '+ client_lname + ' \n id:' + clientId)) {
      console.log("deleting: ", clientId + ' ' + client_updated);

      let clientInfo = {
        "updated": client_updated,
        "active": false
      }

      this.client.deleteClient$(this.contactUUID, clientId, clientInfo).subscribe({
        next: data => {
          console.log("Success deleting client: ", data);
          window.location.reload();
        },
        error: err => {
          confirm('Vous ne pouvez pas supprimer le client  \n' + client_fname + ' '+ client_lname + ' car in a une facture associe a son compte \n id:'+clientId);
          console.log("can't delete client: ", err.error.errors)
        }
      });
    }
  }
}